import * as THREE from 'three';
import PolygonModel from '../PolygonModel';
import Subarray from '../subarray/Subarray';

export default class HeatSolar {
    constructor(stage) {
        this.stage = stage;

        this.objectsGroup = new THREE.Group();
        this.objectsGroup.container = this;
        this.stage.sceneManager.scene.add(this.objectsGroup);

        this.material = new THREE.MeshBasicMaterial();
        this.material.transparent = true;
        this.heatMapEnabled = false;
        this.heatMapTexture = null;

        this.apiLoading = true;
        this.heatMap = null;
        this.solarAccess = null;
    }

    showHeatMap() {
        if (this.heatMap) {
            this.texture = new THREE.TextureLoader().load(this.heatMap);
            this.material.map = this.texture;
            this.material.needsUpdate = true;
            const groundChildren = this.stage.ground.getChildren();
            for (let i = 0; i < groundChildren.length; i++) {
                if (groundChildren[i] instanceof PolygonModel) {
                    groundChildren[i].heatMapTexture = this.texture;
                    groundChildren[i].heatMapEnabled = true;
                    groundChildren[i].addMapTexture();
                }
            }
        }
    }

    hideHeatMap() {
        const groundChildren = this.stage.ground.getChildren();
        for (let i = 0; i < groundChildren.length; i++) {
            if (groundChildren[i] instanceof PolygonModel) {
                groundChildren[i].heatMapEnabled = false;
                groundChildren[i].removeRoofTexture();
            }
        }
    }

    showSolarAccess() {
        this.stage.visualManager.updateVisualsForSolarAccess(true);
    }

    hideSolarAccess() {
        this.stage.visualManager.updateVisualsForSolarAccess(false);
    }

    static _updateSubarraySolarAccess(object, solarAccessMap) {
        for (let child of object.getChildren()) {
            if (child instanceof PolygonModel) {
                HeatSolar._updateSubarraySolarAccess(child, solarAccessMap);
            }
            else if (child instanceof Subarray) {
                child.updateSolarAccess(solarAccessMap[child.id.toString()]);
            }
        }
    }
}